// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@vuepic/vue-datepicker/dist/main.css";

// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        typography: {
          fontFamily: "Trebuchet MS",
        },
      },
    },
  },
});
